import React from 'react';
import { observer } from 'owa-mobx-react';
import { AppFeatureManager, AppTooltipManager, AppWindowProvider } from 'owa-acui';
import { getRibbonExperiments } from '../../util/getRibbonExperiments';

/**
 * Adds essential 1JS context providers for the Ribbon:
 * - `AppFeatureManager`: Enables experimental feature using `getRibbonExperiments`
 * - `AppWindowProvider`: Supplies the current `Window` object to downstream components
 * - `AppTooltipManager`: Enables tooltip functionality
 */
export const RibbonContexts: React.FC<{
    appWindow: Window;
    children: React.ReactNode;
}> = observer(({ appWindow, children }) => {
    return (
        <AppFeatureManager isExperimentalFeatureEnabled={getRibbonExperiments}>
            <AppWindowProvider appWindow={appWindow}>
                <AppTooltipManager>{children}</AppTooltipManager>
            </AppWindowProvider>
        </AppFeatureManager>
    );
}, 'RibbonContexts');
